export function setThemeData(themeData) {
  document.documentElement.style.setProperty(
    '--customer-journey-text-color',
    themeData?.customer_journey_text_color
      ? themeData.customer_journey_text_color
      : '#fff'
  );

  document.documentElement.style.setProperty(
    '--customer-journey-button-first-color',
    themeData?.customer_journey_button_first_color
      ? themeData?.customer_journey_button_first_color
      : '#f89e23'
  );

  document.documentElement.style.setProperty(
    '--customer-journey-button-second-color',
    themeData?.customer_journey_button_second_color
      ? themeData?.customer_journey_button_second_color
      : '#f89e23'
  );

  document.documentElement.style.setProperty(
    '--general-button-text-color',
    themeData?.general_button_text_color
      ? themeData?.general_button_text_color
      : '#fff'
  );

  document.documentElement.style.setProperty(
    '--general-button-first-color',
    themeData?.general_button_first_color
      ? themeData?.general_button_first_color
      : 'rgb(72, 94, 117)'
  );

  document.documentElement.style.setProperty(
    '--general-button-second-color',
    themeData?.general_button_second_color
      ? themeData?.general_button_second_color
      : 'rgb(29, 127, 222)'
  );

  document.documentElement.style.setProperty(
    '--navbar-background--color',
    themeData?.nav_bar_bg_color ? themeData?.nav_bar_bg_color : '#fff'
  );

  document.documentElement.style.setProperty(
    '--navbar-text--color',
    themeData?.nav_bar_text_color ? themeData?.nav_bar_text_color : '#000'
  );

  document.documentElement.style.setProperty(
    '--navbar-selected-text-color',
    themeData?.nav_bar_selected_text_color
      ? themeData?.nav_bar_selected_text_color
      : '#1150A0'
  );

  document.documentElement.style.setProperty(
    '--navbar-selected-bg-color',
    themeData?.nav_bar_selected_bg_color
      ? themeData?.nav_bar_selected_bg_color
      : '#E6EAF1'
  );

  document.documentElement.style.setProperty(
    '--navbar-dropdown-color',
    themeData?.nav_bar_drop_down_color
      ? themeData?.nav_bar_drop_down_color
      : '#000'
  );

  document.documentElement.style.setProperty(
    '--loader-color',
    themeData?.loader_color ? themeData?.loader_color : '#3F51B5'
  );
}
